export default __webpack_public_path__ + "static/media/vedantu.b9bc04b6.jpeg";